import type { CustomCellRendererProps } from 'ag-grid-react';
import { Calendar2, Person } from 'react-bootstrap-icons';

export function DateCell({ valueFormatted }: CustomCellRendererProps) {
  if (!valueFormatted) {
    return '';
  }

  return (
    <div>
      <Calendar2 /> <span>{valueFormatted} </span>
    </div>
  );
}

export function TaxpayerCell({ valueFormatted }: CustomCellRendererProps) {
  if (!valueFormatted) {
    return '';
  }

  return (
    <div>
      <Person /> <span>{valueFormatted} </span>
    </div>
  );
}
